import DashboardLayout from "@/pages/Dashboard/Layout/DashboardLayout.vue";
import AuthLayout from "@/pages/Dashboard/Pages/AuthLayout.vue";

// Dashboard pages
import Dashboard from "@/pages/Dashboard/Dashboard.vue";

// Calendar
import Calendar from "@/pages/Dashboard/Calendar.vue";
// Charts
import Charts from "@/pages/Dashboard/Charts.vue";
import Widgets from "@/pages/Dashboard/Widgets.vue";

//Merchants
import MerchantList from "@/pages/Merchants/List";
import MerchantsEdit from "@/pages/Merchants/Edit";

// Orders
import OrdersList from "@/pages/Orders/List"

//Users
import UsersList from "@/pages/Users/List"
import UserDetail from "@/pages/Users/Detail"

//User Phones
import UserPhonesList from "@/pages/UserPhones/List"

// Reports
import MerchantOrdersReport from "@/pages/Reports/MerchantOrdersList"
import MerchantOrdersReportV2 from "@/pages/Reports/MerchantOrdersListV2"
import FailedOrdersList from "@/pages/FailedOrders/List"

// Rewards
import RewardsList from "@/pages/Rewards/List";
import RewardsForm from "@/pages/Rewards/Form";

// Presets Categories
import CategoriesList from "@/pages/Presets Categories/List";
import FormCategories from "@/pages/Presets Categories/Form";

//Presets
import Presets from "@/pages/Presets/List";
import FormPresets from "@/pages/Presets/Form";

// Config
import Config from "@/pages/Config/Current";
import EditConfig from "@/pages/Config/Edit";
import ConfigHistory from "@/pages/Config/History";

// Deposits
import BatchedDepositsList from "@/pages/BatchedDeposits/List";
import BatchedDepositDetail from "@/pages/BatchedDeposits/Detail";

// Allowance Recipients
import AllowanceRecipientsList from "@/pages/AllowanceRecipients/List";

//Auth
import Auth from "@/pages/Auth/Login";
import AuthRegister from "@/pages/Auth/Register";

let presets = {
  path: "/preset_items",
  component: DashboardLayout,
  children: [
    {
      path: "/",
      name: "List of Presets",
      component: Presets
    },
    {
      path: "new",
      name: "NewPresets",
      component: FormPresets
    },
    {
      path: ":id/edit",
      name: "EditPresets",
      component: FormPresets
    },
  ]
};

let presets_list = {
  path: "/preset_lists",
  component: DashboardLayout,
  children: [
    {
      path: "/",
      name: "Categorie Lists",
      component: CategoriesList
    },
    {
      path: "new",
      name: "New Categories",
      component: FormCategories
    },
    {
      path: ":id/edit",
      name: "Edit Category",
      component: FormCategories
    },
  ]
};

let merchants = {
  path:"/merchants",
  component: DashboardLayout,
  children: [
    {
      path: "/",
      name: "Merchant List",
      component: MerchantList
    },
    {
      path: ":id/edit",
      name: "Edit Merchant",
      component: MerchantsEdit
    }
  ]
};

let users = {
  path: "/users",
  component: DashboardLayout,
  children: [
    {
      path: "/",
      name: "Users List",
      component: UsersList
    },
    {
      path: ":id",
      name: "User Detail",
      component: UserDetail
    }
  ]
};

let user_phones = {
  path: "/user-phones",
  component: DashboardLayout,
  children: [
    {
      path: "/",
      name: "User Phones List",
      component: UserPhonesList
    }
  ]
};

let reports = {
  path: "/",
  component: DashboardLayout,
  children: [
    {
      path: "v1/merchant-report",
      name: "Legacy Merchant Report",
      component: MerchantOrdersReport
    },
    {
      path: "v2/merchant-report",
      name: "Merchant Report",
      component: MerchantOrdersReportV2
    },
    {
      path: "failed-orders",
      name: "Failed Order List",
      component: FailedOrdersList
    }
  ]
};

let rewards = {
  path: "/rewards",
  component: DashboardLayout,
  children: [
    {
      path: "/",
      name: "Rewards List",
      component: RewardsList
    },
    {
      path: "new",
      name: "New Rewards",
      component: RewardsForm
    },
    {
      path: ":id/edit",
      name: "Edit Rewards",
      component: RewardsForm
    }
  ]
};

let orders = {
  path: "/orders",
  component: DashboardLayout,
  children: [
    {
      path: "/",
      name: "Order List",
      component: OrdersList
    },
  ]
};

let config = {
  path: "/config",
  component: DashboardLayout,
  children: [
    {
      path: "/",
      name: "Config",
      component: Config
    },
    {
      path: "history",
      name: "Config History",
      component: ConfigHistory
    },
    {
      path: "edit",
      name: "Edit Config",
      component: EditConfig
    },
  ]
};

let deposits = {
  path: "/deposits",
  component: DashboardLayout,
  children: [
    {
      path: "/",
      name: "Batched Deposits",
      component: BatchedDepositsList
    },
    {
      path: ":nodeId",
      name: "Batched Deposit",
      component: BatchedDepositDetail
    },
  ]
};

let allowance_recipients = {
  path: "/allowance-recipients",
  component: DashboardLayout,
  children: [
    {
      path: "/",
      name: "Allowance Recipients",
      component: AllowanceRecipientsList
    },
  ]
};

let auth = {
  path: "/",
  component: AuthLayout,
  name: "Authentication",
  children: [
    {
      path: "signin",
      name: "Login",
      component: Auth
    }
  ]
};

const routes = [
  {
    path: "/",
    redirect: "/signin",
    name: "InitialLogin"
  },
  presets,
  presets_list,
  rewards,
  merchants,
  orders,
  auth,
  reports,
  users,
  user_phones,
  config,
  deposits,
  allowance_recipients
];

export default routes;
